import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

function getTimeLeft(expiresAt) {
  const diff = new Date(expiresAt) - new Date();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}

export default function CountdownTimer({ expiresAt, className = '' }) {
  const [left, setLeft] = useState(() => getTimeLeft(expiresAt));

  useEffect(() => {
    const id = setInterval(() => setLeft(getTimeLeft(expiresAt)), 1000);
    return () => clearInterval(id);
  }, [expiresAt]);

  if (!left) {
    return (
      <span className={`text-rose-600 text-sm font-medium ${className}`}>Expiré</span>
    );
  }

  const parts = [];
  if (left.d > 0) parts.push(`${left.d}j`);
  parts.push(`${String(left.h).padStart(2, '0')}h`);
  parts.push(`${String(left.m).padStart(2, '0')}m`);
  if (left.d === 0) parts.push(`${String(left.s).padStart(2, '0')}s`);

  const urgent = left.d === 0 && left.h < 12;

  return (
    <div className={`flex items-center gap-1.5 ${urgent ? 'text-rose-600' : 'text-slate-700'} ${className}`}>
      <Clock className="w-4 h-4" />
      <span className="text-sm font-mono font-medium">{parts.join(' ')}</span>
    </div>
  );
}
